module.exports = __webpack_public_path__ + "static/img/cmst_logo.d01f47e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cmst_logo.png
// module id = kQm0
// module chunks = 1